import React, { Component } from 'react';
import FieldWrapper from '../form.components/field.wrapper.jsx';
import RowSection from '../pages/row.section.jsx';
import FieldRow from '../pages/field.row.jsx';
import QuestionnaireLinkRow from '../pages/questionnaire.link.row.jsx';
import Page from '../pages/page.layout.jsx';
import FinishPage from '../pages/finish.page.layout.jsx';
import { initPages, initNavigationPages, setActivePage, setLastPage, setFieldValue } from '../app.reducer.jsx';
import { bindActionCreators } from '../app.store.jsx';
import { isEmptyValue } from '../../common/utils.jsx';
import { animateScrollToPage, dropGroups, mapPageToNavigationElement } from '../questionnaire.utils.jsx';
import { NODE_TYPE_FIELD, NODE_TYPE_FINISH_PAGE, NODE_TYPE_SECTION, NODE_TYPE_ROW, NODE_TYPE_PAGE } from './node.types.jsx';

export class SectionConstructor extends Component {
    render() {
        const { id, nodeType, fieldValues, props, components, isActive } = this.props;
        const fields = this.props.childrenNodes;
        if (NODE_TYPE_SECTION !== nodeType) { throw new TypeError(`rowConstructor() error: field.nodeType doesn't math ${NODE_TYPE_ROW}`); }
        if (isEmptyValue(id)) { throw new TypeError(`rowConstructor() error: invalid field id: ${id}`); }
        if (false === (fields instanceof Array) || 0 === fields.length) { throw new Error('rowConstructor() error: fields array are empty or broken'); }
        let rowIndex = 0;
        const childrenFields = fields.map((item) => {
            const itemProps = item.props;
            const childrenProps = { isActive, components, fieldValues, key: item.key };
            if (NODE_TYPE_FIELD === item.nodeType) {
                return <FieldWrapper {...item} {...itemProps} {...childrenProps} index={item.number || rowIndex++}/>;
            } else if (NODE_TYPE_ROW === item.nodeType) {
                return <RowConstructor {...item} {...childrenProps}/>;
            }
            throw new TypeError(`Unknown nodeType: ${item.nodeType}`);
        });
        return (
            <RowSection id={`section-${id}`} fieldValues={fieldValues} {...props} components={components}>
                {childrenFields}
            </RowSection>
        );
    }
}

export class RowConstructor extends Component {
    render() {
        const { id, nodeType, props, fieldValues, index, isActive, components } = this.props;
        const fields = this.props.childrenNodes;
        if (NODE_TYPE_ROW !== nodeType) { throw new TypeError(`rowConstructor() error: field.nodeType doesn't math ${NODE_TYPE_ROW}`); }
        if (isEmptyValue(id)) { throw new TypeError(`rowConstructor() error: invalid field id: ${id}`); }
        if ('welcome-page' === id) { return <QuestionnaireLinkRow />; }
        if ('final-step' !== id && (false === (fields instanceof Array) || 0 === fields.length)) { throw new Error('rowConstructor() error: fields array are empty or broken'); }
        const childrenFields = fields.map((item) => {
            const childrenProps = { isActive, fieldValues, components, key: item.key };
            if (NODE_TYPE_FIELD === item.nodeType) {
                return <FieldWrapper {...childrenProps} {...item}/>;
            } else if (NODE_TYPE_SECTION === item.nodeType) {
                return <SectionConstructor {...childrenProps} {...item}/>;
            }
            throw new TypeError(`Unknown nodeType: ${item.nodeType}`);
        });
        const newProps = {
            id: `row-${id}`, number: index + 1,
            fieldValues, isActive, props
        };
        return (
            <FieldRow {...newProps}>
                {childrenFields}
            </FieldRow>
        );
    }
}


export class PageConstructor extends Component {
    render() {
        const { pedigreeGenerated, fieldsMap, id, nodeType, props, fieldValues, currentPageIndex, pages,
            lastPageIndex, height, components, actionObject, token, language } = this.props;
        const rows = this.props.childrenNodes;
        let isActive = false;
        if (0 < pages.length) {
            isActive = id === pages[currentPageIndex].id;
        }
        if (nodeType === NODE_TYPE_FINISH_PAGE) {
            return <FinishPage pedigreeGenerated={pedigreeGenerated} language={language}
                               fieldsMap={fieldsMap} pageList={pages} token={token}
                               fields={fieldValues} height={height}
            />;
        }
        if (NODE_TYPE_PAGE !== nodeType) { throw new TypeError(`pageConstructor() error: field.nodeType doesn't math ${NODE_TYPE_PAGE}`); }
        if (isEmptyValue(id)) { throw new TypeError(`pageConstructor() error: invalid field id: ${id}`); }
        if (false === (rows instanceof Array) || 0 === rows.length) { throw new Error('pageConstructor() error: rows array are empty or broken'); }
        let rowIndex = 0;
        const childrenRows = rows.map((item) => {
            const childrenProps = { isActive, fieldValues, components, key: item.key };
            if (NODE_TYPE_ROW === item.nodeType) {
                return <RowConstructor {...childrenProps} {...item} index={item.number || rowIndex++}/>;
            } else if (NODE_TYPE_SECTION === item.nodeType) {
                return <SectionConstructor {...childrenProps} {...item}/>;
            }
            throw new TypeError(`Unknown nodeType: ${item.nodeType}`);
        });
        const pageProps = {
            id: `page-${id}`, pageName: id,
            isActive, height, fieldValues, lastPageIndex, pages, currentPageIndex, actionObject
        };
        return <Page {...pageProps} {...props}>{childrenRows}</Page>;
    }
}

export default function questionnaireConstructor(config) {
  const parsedConfig = 'string' === typeof config ? JSON.parse(config) : config;
  const pages = parsedConfig.childrenNodes;
  return class QuestionnaireConstructorClass extends Component {
    constructor(props) {
      super(props);
      this._initPages = bindActionCreators(initPages);
      this._initNavigationPages = bindActionCreators(initNavigationPages);
      this._setActivePage = bindActionCreators(setActivePage);
      this._setLastPage = bindActionCreators(setLastPage);
      this._setFieldValue = bindActionCreators(setFieldValue);

      const navigationArray = pages.map(mapPageToNavigationElement);
      const pagesIdArray = navigationArray.filter(dropGroups);
      this._initPages(pagesIdArray);
      this._initNavigationPages(navigationArray);
      const fields = this.props.fields.toJS();
      const { pages: pageList, finished } = fields;
      const { currentPageIndex, lastPageIndex } = pageList;
      if (pageList && 0 <= currentPageIndex) {
        this._setActivePage(currentPageIndex);
        animateScrollToPage(currentPageIndex, finished);
        this._setLastPage(lastPageIndex);
      } else {
        this._setFieldValue('lastPageIndex', 0, 'pages');
        this._setFieldValue('currentPageIndex', 0, 'pages');
      }
    }

    render() {
      const {
        fields,
        currentPageIndex,
        pageList,
        lastPageIndex,
        height,
        components,
        language,
        pedigreeGenerated,
        token,
      } = this.props;
      let _fields = fields;
      const fieldsMap = parsedConfig.extractFields(fields.toJS());
      if ('function' === typeof fields.toJS) { _fields = fields.toJS(); }
      const props = {
        fieldsMap,
        components,
        token,
        currentPageIndex,
        lastPageIndex,
        pages: pageList,
        height,
        fieldValues: _fields,
        language,
        pedigreeGenerated,
      };
      return (
        <div className="questionnaire-constructor-wrapper">
          {pages.filter(dropGroups).map((item) => (
            <PageConstructor {...item} {...props} key={item.key} />
          ))}
        </div>
      );
    }
  };
}
